import { type z } from 'zod'

import { type schemas } from '~interface/zod-schema'

import { type LocationValue0 } from './values'

export type Address0 = z.infer<typeof schemas.Address0>

export type AddressBase = z.infer<typeof schemas.AddressBase>

export type GeoPoint = z.infer<typeof schemas.GeoPoint>

export type Location0 = z.infer<typeof schemas.Location0>

export function formatAddress0(address: Address0 | LocationValue0): string {
  return `${address.street}, ${address.city}, ${address.state} ${address.zip}`
}
